var map = {
	"./blogs.json": "fac6",
	"./cases.json": "122f",
	"./forms/contact_us.json": "7b3c",
	"./forms/contact_us_cn.json": "4209",
	"./forms/email_subscription.json": "b125",
	"./globals/agile_teams.json": "a033",
	"./globals/footer.json": "0e41",
	"./globals/settings.json": "a654",
	"./pages/about.json": "1789",
	"./pages/blog.json": "33d5",
	"./pages/contact-us.json": "f5ce",
	"./pages/home.json": "8767",
	"./pages/open-source.json": "ee18",
	"./pages/what-we-do.json": "3bce",
	"./services.json": "52dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cea0";